function newsletter(){
    const newsletterContainers = document.querySelectorAll('.newsletter-container');

    newsletterContainers.forEach(function(container) {
        container.querySelectorAll('.toggle-switch').forEach(toggle => {
            toggle.addEventListener('click', function() {
                this.classList.toggle('active');
            });
        });

        const newsletterForm = container.querySelector('.newsletterForm');
        if (newsletterForm) {
            newsletterForm.addEventListener('submit', function (e) {
                e.preventDefault();

                const selectedPreferences = [];
                container.querySelectorAll('.toggle-switch.active').forEach(toggle => {
                    selectedPreferences.push(toggle.dataset.preference);
                });

                const formData = new FormData(this);

                const submitBtn = this.querySelector('button[type="submit"]');
                const originalText = submitBtn.textContent;
                submitBtn.disabled = true;

                fetch(ajax_object.ajax_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: 'newsletter_signup',
                        newsletter_name: formData.get('newsletter_name'),
                        newsletter_email: formData.get('newsletter_email'),
                        preferences: selectedPreferences,
                        nonce: ajax_object.nonce
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            newsletterForm.reset();
                            const popup = document.getElementById('newsletter-success-popup');
                            const closeBtn = popup.querySelector('.popup-close');
                            const okBtn = popup.querySelector('.popup-ok-btn');
                            container.querySelectorAll('.toggle-switch').forEach(toggle => {
                                toggle.classList.remove('active');
                            });
                            popup.style.display = 'block';
                            document.body.style.overflow = 'hidden';
                            console.log('Newsletter signup successful:', data);
                            function closePopup() {
                                popup.style.display = 'none';
                                document.body.style.overflow = 'auto';
                            }

                            closeBtn.addEventListener('click', closePopup);
                            okBtn.addEventListener('click', closePopup);

                            popup.querySelector('.popup-overlay').addEventListener('click', closePopup);

                        } else {
                            alert('Błąd: ' + data.data.message);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    })
                    .finally(() => {
                        // Restore button state
                        submitBtn.textContent = originalText;
                        submitBtn.disabled = false;
                    });
            });
        }
    });
}

export default {newsletter};